import Vue from "vue";

//全局枚举常量，使用CONST.常量名
import consts from './global/consts'
Vue.use(consts);

import App from "./App.vue";
import router from "./router";
import store from "./store";

//引入
import echartsGL from "echarts-gl" 
Vue.prototype.$echartsGL = echartsGL

import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;

//引入elementui
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI, { size: "mini" });

//解决导航收缩文字不完全影藏，先安装cnpm install --save vue-fragment，然后将导航菜单用fragment包裹起来
import Fragment from "vue-fragment";
Vue.use(Fragment.Plugin);

//全局函数
import eventBus from "./global/eventBus.js";
Vue.prototype.$eventBus = eventBus;

// //全局变量，对象设置,使用this.方法名，存储sessionStorage到,从sessionStorage读取值
import global from "./global/global";
Vue.use(global);

//消息弹窗封装引入
import messageUtils from "./utils/messageUtils";
Vue.prototype.$message = messageUtils;

//引入tzmap
import "ituzhi-map-view/lib/theme-chalk/map.css";
import MapView from "ituzhi-map-view";
Vue.use(MapView);

//引入公共过滤器
import commonFilter from "./utils/filter";
for(let key in commonFilter){
  Vue.filter(key,commonFilter[key])
}

//引入阿里图标
import "./assets/icon/iconfont/iconfont.js";
import "./assets/icon/iconfont/iconfont.css";

//引入 driver css
import 'driver.js/dist/driver.min.css'


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
